module.exports = __webpack_public_path__ + "static/media/group_guide_img_3.6722ae5f.png";